import AnimateOnEnter from "@/ui/animations/AnimateOnEnter"
import CtaLink2 from "@/ui/atoms/CtaLink2"
import Typography from "@/ui/atoms/Typography"
import Container from "@/ui/structure/Container"
import { CtaData } from "@/ui/types/cta"
import { classNames } from "@punks/ui-core"
import { ReactNode } from "react"

export type TextImageOrientation = "default" | "reverse"

export interface TextImageBlockProps {
  image: ReactNode
  title?: ReactNode
  bodyTitle?: ReactNode
  text?: ReactNode
  cta?: CtaData
  decoration?: ReactNode
  orientation?: TextImageOrientation
}

const TextImageBlock = ({
  image,
  text,
  title,
  bodyTitle,
  cta,
  decoration,
  orientation = "default",
}: TextImageBlockProps) => {
  return (
    <div className="relative mt-24 mb-8 xl:my-16">
      {decoration && (
        <AnimateOnEnter delay={250} animationType="fadeIn">
          <div className="absolute inset-0 z-[-1]">{decoration}</div>
        </AnimateOnEnter>
      )}

      {title && (
        <Container className="text-center xl:text-left">
          <Typography variant="subtitle2" weight={"bold"} className="xl:mb-16">
            {title}
          </Typography>
        </Container>
      )}

      <Container
        className={classNames("flex flex-col gap-20", {
          "xl:flex-row-reverse": orientation === "reverse",
          "xl:flex-row": orientation === "default",
        })}
      >
        <div className="xl:flex-1 xl:mb-16">
          <AnimateOnEnter animationType="fadeIn" delay={250}>
            {bodyTitle && (
              <Typography
                variant={["subtitle2", "h2"]}
                className="mb-8 xl:mb-16"
                weight={"bold"}
              >
                {bodyTitle}
              </Typography>
            )}
            {text && <Typography variant="body1">{text}</Typography>}
            {cta && (
              <div className="text-center my-12 xl:text-left">
                <CtaLink2 {...cta} />
              </div>
            )}
          </AnimateOnEnter>
        </div>
        {image && (
          <div className="hidden xl:block min-h-[20vh] xl:w-[49%] -mx-container xl:mx-0">
            {image}
          </div>
        )}
      </Container>
    </div>
  )
}

export default TextImageBlock
